import React from "react";
import StudentsIcon from "./../../images/students-dashboard.svg";
import TeachersIcon from "./../../images/teacher-dashboard-com.svg";
import { SmallCardLists } from "../card/SmallCardLists";
import { useGetOverviewData } from "../../hooks/parentsHooks/useParents.hooks";
import { getValue } from "../../utils/object.utils";

export const OverViewInfo = () => {
  const { isLoading: isOverViewDataLoading, data: overViewData } =
    useGetOverviewData();

  if (isOverViewDataLoading) {
    return <></>;
  }

  const transformedData = [
    {
      image: TeachersIcon,
      title: "Total children",
      value: getValue(overViewData, "childCount", 0),
      color: "#3f7afc",
    },
    {
      image: TeachersIcon,
      title: "Notification",
      value: "0",
      color: "#3f7afc",
    },
    {
      image: StudentsIcon,
      title: "Result",
      value: "0",
      color: "#3cb878",
    },
  ];
  return (
    <>
      <SmallCardLists data={transformedData} />
    </>
  );
};
